<template>
    <ContentCard icon="assets/images/illu-bee.svg">
        <template #title>The BEES KNEES - HOW DOES A PRINCESS BECOME A QUEEN?</template>
        <template #description>Learn how a princess bee becomes a queen and much more about our
            stingless bees in Australia!
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', 'J5e5fsNunX0')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/Sketching-Bee.pdf" target="_blank" icon="file" class="card__btn"
                        orange>ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>
